export const getters = {
  cities: state => state.all.cities,
  countries: state => state.all.countries
}

export default {
  all: {
    cities: [],
    countries: []
  }
}
